<template>
  <a-auto-complete
    :placeholder="$props.placeholder"
    :data-source="data"
    :filter-option="false"
    @change="handleChange"
  />
</template>

<script type="text/ecmascript-6">
  import { AutoComplete } from 'ant-design-vue'
  import { getDictionary } from '../api'

  export default {
    components: {
      AAutoComplete: AutoComplete,
    },
    data() {
      return {
        originDataLists: [],
        data: [],
      }
    },
    props: ['code', 'placeholder'],
    mounted() {
      getDictionary(this.code).then(res => {
        if(res.success) {
          this.originDataLists = res.data.map(item => item.displayname)
        }
      })
    },
    methods: {
      handleChange(value) {
        if(value) {
          this.data = this.originDataLists.filter(item => item.toUpperCase().includes(value.toUpperCase()))
        }
        this.$emit('change', value)
      },
    }
  }
</script>

<style>

</style>
